import classNames from "classnames";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import logoPoolTonight from "../../assets/logo-pooltonight.png";
import useIsMobile from "../../hooks/use-is-mobile";
import { SitePage } from "../../types/SitePage";
import "./TopNav.scss";
import { useUserSessionLinks } from "./useUserSessionLinks";

interface TopNavProps {
  page: SitePage;
}

const TopNav: React.FC<TopNavProps> = ({ page }) => {
  const isMobile = useIsMobile();

  const showActivity = false;

  const [isNavOpen, setIsNavOpen] = useState(false);
  const { links: userSessionBarLinks, moreDropdownLinks } =
    useUserSessionLinks();

  const navClass = classNames(
    "top-nav navbar navbar-expand-sm navbar-light bg-dark",
    {
      [page]: true,
      "fixed-top": isMobile,
    }
  );

  return (
    <nav className={navClass}>
      <div className="nav-content container-fluid">
        <Link to="/map" className="nav-brand-link navbar-brand">
          <img
            src={logoPoolTonight}
            alt="Pool Tonight Logo"
            className="nav-logo d-inline-block align-text-top"
          />
          <span className="nav-brand">Pool Tonight</span>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsNavOpen(!isNavOpen)}
          aria-controls="navbarNav"
          aria-expanded={isNavOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse ${isNavOpen ? "show" : ""}`}
          id="navbarNav"
        >
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link to="/map" className="nav-link">
                Map
              </Link>
            </li>
            {showActivity && (
              <li className="nav-item">
                <Link to="/feed" className="nav-link">
                  Activity
                </Link>
              </li>
            )}
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                More
              </span>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="navbarDropdown"
              >
                <li>
                  <Link to="/about" className="dropdown-item">
                    About Pool Tonight
                  </Link>
                </li>
                {moreDropdownLinks}
              </ul>
            </li>
            {userSessionBarLinks}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default TopNav;
